import React, { useState, useEffect } from 'react';
import { db } from '../firebase';
import { collection, onSnapshot, addDoc, updateDoc, doc, increment, serverTimestamp, query, where, orderBy } from 'firebase/firestore';

const StaffManager = () => {
    const [personeller, setPersoneller] = useState([]);
    const [projeler, setProjeler] = useState([]);
    const [seciliPersonel, setSeciliPersonel] = useState(null);
    const [hareketler, setHareketler] = useState([]);
    const [showAddModal, setShowAddModal] = useState(false);
    
    // Detaylı Personel Stateleri
    const [yeniPersonel, setYeniPersonel] = useState({ 
        adSoyad: "", telefon: "", dogumTarihi: "", uyruk: "TC", 
        anaProje: "", aciklama: "", ehliyet: "Yok", diller: "",
        calismaTipi: "yevmiye", varsayilanUcret: 0 
    });

    const [islem, setIslem] = useState({ 
        personelId: "", tip: "hakedis", miktar: 0, aciklama: "", 
        proje: "", adet: 0, birimUcret: 0 
    });

    useEffect(() => {
        onSnapshot(collection(db, "personel"), (snap) => {
            setPersoneller(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
        onSnapshot(collection(db, "projeler"), (snap) => {
            setProjeler(snap.docs.map(d => ({ id: d.id, ...d.data() })));
        });
    }, []);

    // DETAYLARIN GELMESİ İÇİN GÜVENLİ SORGU
    useEffect(() => {
        if (seciliPersonel) {
            // orderBy("tarih") kısmını sildim ki index hatası vermeden veriyi çekebilsin. 
            // Veri geldikten sonra JS ile sıralayacağız.
            const q = query(collection(db, "personel_hareketleri"), where("personelId", "==", seciliPersonel.id));
            
            const unsub = onSnapshot(q, (snap) => {
                const docs = snap.docs.map(d => ({ id: d.id, ...d.data() }));
                // JS tarafında tarihe göre sıralama (En yeni üstte)
                const sorted = docs.sort((a, b) => (b.tarih?.seconds || 0) - (a.tarih?.seconds || 0));
                setHareketler(sorted);
            });
            return () => unsub();
        }
    }, [seciliPersonel]);

    const personelEkle = async () => {
        if (!yeniPersonel.adSoyad) return alert("İsim zorunludur!");
        await addDoc(collection(db, "personel"), { ...yeniPersonel, bakiye: 0, kayitTarihi: serverTimestamp() });
        setShowAddModal(false);
        setYeniPersonel({ adSoyad: "", telefon: "", dogumTarihi: "", uyruk: "TC", anaProje: "", aciklama: "", ehliyet: "Yok", diller: "", calismaTipi: "yevmiye", varsayilanUcret: 0 });
    };

    const islemYap = async () => {
        if (!islem.personelId || !islem.miktar || !islem.proje) return alert("Lütfen Personel, Proje ve Tutar girin!");
        const personelRef = doc(db, "personel", islem.personelId);
        const degisim = islem.tip === "hakedis" ? parseFloat(islem.miktar) : -parseFloat(islem.miktar);

        await updateDoc(personelRef, { bakiye: increment(degisim) });
        await addDoc(collection(db, "personel_hareketleri"), { ...islem, tarih: serverTimestamp() });
        setIslem({ ...islem, miktar: 0, adet: 0, aciklama: "" });
        alert("İşlem kaydedildi!");
    };

    return (
        <div className="flex flex-col gap-4 text-white p-2">
            
            {/* ÜST AKSİYON ÇUBUĞU */}
            <div className="flex justify-between items-center bg-slate-900 p-4 rounded-3xl border border-slate-800 print:hidden">
                <h1 className="text-xl font-black italic uppercase tracking-tighter text-blue-500">Personel & Hakediş Sistemi</h1>
                <button onClick={() => setShowAddModal(true)} className="bg-blue-600 px-6 py-2 rounded-xl font-black text-xs uppercase hover:bg-blue-500 transition-all">+ Yeni Personel Kartı</button>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
                
                {/* SOL: PERSONEL LİSTESİ */}
                <div className="bg-slate-900 rounded-[2rem] border border-slate-800 h-[700px] overflow-hidden flex flex-col print:hidden">
                    <div className="p-4 border-b border-slate-800 bg-slate-950/50">
                        <input placeholder="Personel Ara..." className="w-full bg-slate-900 border border-slate-800 p-2 rounded-lg text-xs outline-none focus:border-blue-500" />
                    </div>
                    <div className="overflow-y-auto p-2 flex-1 custom-scrollbar">
                        {personeller.map(p => (
                            <div key={p.id} onClick={() => setSeciliPersonel(p)} 
                                 className={`p-4 rounded-2xl border mb-2 cursor-pointer transition-all ${seciliPersonel?.id === p.id ? 'bg-blue-600 border-blue-400' : 'bg-slate-950 border-slate-800'}`}>
                                <p className="font-black text-xs uppercase">{p.adSoyad}</p>
                                <div className="flex justify-between mt-1 opacity-60">
                                    <span className="text-[9px] font-bold uppercase">{p.anaProje || 'Genel'}</span>
                                    <span className="text-[10px] font-black">₺{p.bakiye?.toLocaleString()}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>

                {/* ORTA: DETAY KARTI VE HAREKETLER */}
                <div className="lg:col-span-3 flex flex-col gap-6">
                    
                    {/* HIZLI İŞLEM PANELİ (Hakediş/Ödeme) */}
                    <div className="bg-slate-900 p-6 rounded-[2rem] border border-slate-800 print:hidden">
                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 items-end">
                            <div className="md:col-span-1">
                                <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">Personel & Proje</label>
                                <select className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl text-xs" value={islem.personelId} onChange={e => setIslem({...islem, personelId: e.target.value})}>
                                    <option value="">İşçi Seç...</option>
                                    {personeller.map(p => <option key={p.id} value={p.id}>{p.adSoyad}</option>)}
                                </select>
                                <select className="w-full bg-slate-950 border border-blue-900/30 p-3 rounded-xl text-xs text-blue-400 mt-2" value={islem.proje} onChange={e => setIslem({...islem, proje: e.target.value})}>
                                    <option value="">Proje Seç...</option>
                                    {projeler.map(p => <option key={p.id} value={p.ad}>{p.ad}</option>)}
                                </select>
                            </div>
                            <div>
                                <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">İşlem Tipi & Miktar</label>
                                <div className="flex gap-1 mb-2">
                                    <button onClick={() => setIslem({...islem, tip:'hakedis'})} className={`flex-1 p-2 rounded-lg text-[9px] font-black border ${islem.tip==='hakedis'?'bg-emerald-600':'bg-slate-950'}`}>HAKEDİŞ</button>
                                    <button onClick={() => setIslem({...islem, tip:'odeme'})} className={`flex-1 p-2 rounded-lg text-[9px] font-black border ${islem.tip==='odeme'?'bg-red-600':'bg-slate-950'}`}>ÖDEME</button>
                                </div>
                                <div className="flex gap-2">
                                    <input type="number" placeholder="Adet" className="w-1/2 bg-slate-950 border border-slate-800 p-3 rounded-xl text-center font-bold" onChange={e => {
                                        const adet = e.target.value;
                                        setIslem({...islem, adet: adet, miktar: adet * islem.birimUcret});
                                    }} />
                                    <input type="number" placeholder="Birim" className="w-1/2 bg-slate-950 border border-slate-800 p-3 rounded-xl text-center font-bold text-emerald-500" onChange={e => {
                                        const birim = e.target.value;
                                        setIslem({...islem, birimUcret: birim, miktar: islem.adet * birim});
                                    }} />
                                </div>
                            </div>
                            <div className="md:col-span-1">
                                <label className="text-[10px] font-black text-slate-500 ml-2 uppercase">Açıklama</label>
                                <input placeholder="Notunuz..." className="w-full bg-slate-950 border border-slate-800 p-3 rounded-xl text-xs mb-2" value={islem.aciklama} onChange={e => setIslem({...islem, aciklama: e.target.value})} />
                                <div className="text-center font-black text-xl">₺{Number(islem.miktar || 0).toLocaleString()}</div>
                            </div>
                            <button onClick={islemYap} className="bg-orange-600 w-full p-4 rounded-xl font-black uppercase text-xs hover:scale-95 transition-all">Kaydet</button>
                        </div>
                    </div>

                    {/* PERSONEL KARTI (BEYAZ ÇIKTI ALANI) */}
                    <div className="bg-white text-black rounded-[2.5rem] p-8 min-h-[500px] shadow-2xl print:m-0">
                        {seciliPersonel ? (
                            <>
                                <div className="flex justify-between border-b-4 border-black pb-4 mb-6">
                                    <div>
                                        <h2 className="text-4xl font-black uppercase italic tracking-tighter">{seciliPersonel.adSoyad}</h2>
                                        <div className="grid grid-cols-2 gap-x-8 gap-y-1 mt-2 text-[10px] font-bold text-slate-500 uppercase">
                                            <span>📞 {seciliPersonel.telefon}</span>
                                            <span>🌍 {seciliPersonel.uyruk}</span>
                                            <span>🎂 {seciliPersonel.dogumTarihi}</span>
                                            <span>🪪 Ehliyet: {seciliPersonel.ehliyet}</span>
                                            <span>🗣️ Diller: {seciliPersonel.diller}</span>
                                            <span>🚀 Proje: {seciliPersonel.anaProje}</span>
                                        </div>
                                    </div>
                                    <div className="text-right">
                                        <p className="text-[10px] font-black text-slate-400 uppercase">Toplam Bakiye</p>
                                        <p className="text-5xl font-black leading-none">₺{seciliPersonel.bakiye?.toLocaleString()}</p>
                                    </div>
                                </div>
                                <table className="w-full text-[11px]">
                                    <thead>
                                        <tr className="border-b-2 border-black text-left uppercase font-black">
                                            <th className="p-2">Tarih</th>
                                            <th className="p-2">Proje</th>
                                            <th className="p-2">Açıklama</th>
                                            <th className="p-2 text-center">Miktar/Birim</th>
                                            <th className="p-2 text-right">Tutar</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {hareketler.map(h => (
                                            <tr key={h.id} className="border-b border-slate-100 italic">
                                                <td className="p-2 font-bold">{h.tarih?.toDate().toLocaleDateString('tr-TR')}</td>
                                                <td className="p-2 font-black text-blue-700 uppercase">{h.proje}</td>
                                                <td className="p-2 text-slate-500">{h.aciklama}</td>
                                                <td className="p-2 text-center font-bold">{h.adet > 0 ? `${h.adet} x ₺${h.birimUcret}` : '-'}</td>
                                                <td className={`p-2 text-right font-black ${h.tip==='hakedis'?'text-emerald-600':'text-red-600'}`}>
                                                    {h.tip==='hakedis'?'+':'-'} ₺{h.miktar?.toLocaleString()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                                <button onClick={() => window.print()} className="mt-8 bg-black text-white px-8 py-2 rounded-full font-black text-[10px] uppercase print:hidden">Yazdır</button>
                            </>
                        ) : (
                            <div className="h-full flex items-center justify-center opacity-20 font-black text-2xl italic uppercase">Bir Personel Seçin</div>
                        )}
                    </div>
                </div>
            </div>

            {/* YENİ PERSONEL MODAL (AYRI SAYFA GİBİ) */}
            {showAddModal && (
                <div className="fixed inset-0 bg-black/90 backdrop-blur-sm z-[100] flex items-center justify-center p-4">
                    <div className="bg-slate-900 border border-slate-800 w-full max-w-2xl rounded-[3rem] p-8 shadow-2xl overflow-y-auto max-h-[90vh]">
                        <div className="flex justify-between items-center mb-8">
                            <h2 className="text-2xl font-black uppercase italic text-blue-500">Yeni Personel Kartı Oluştur</h2>
                            <button onClick={() => setShowAddModal(false)} className="text-slate-500 font-black">KAPAT</button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 font-bold">
                            <div className="flex flex-col gap-4 text-xs">
                                <label className="ml-2 uppercase text-slate-500">Temel Bilgiler</label>
                                <input placeholder="AD SOYAD *" className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, adSoyad: e.target.value})} />
                                <input placeholder="TELEFON" className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, telefon: e.target.value})} />
                                <input type="date" className="bg-slate-950 p-4 rounded-2xl border border-slate-800 text-slate-400" onChange={e => setYeniPersonel({...yeniPersonel, dogumTarihi: e.target.value})} />
                                <input placeholder="UYRUK (TC, SURİYE, VS)" className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, uyruk: e.target.value})} />
                            </div>
                            <div className="flex flex-col gap-4 text-xs">
                                <label className="ml-2 uppercase text-slate-500">Yeterlilik & Atama</label>
                                <select className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, anaProje: e.target.value})}>
                                    <option value="">SABİT PROJE ATAMASI (VARSA)</option>
                                    {projeler.map(p => <option key={p.id} value={p.ad}>{p.ad}</option>)}
                                </select>
                                <select className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, ehliyet: e.target.value})}>
                                    <option value="Yok">EHLİYET VAR MI?</option>
                                    <option value="B Sınıfı">B Sınıfı</option>
                                    <option value="C/D Sınıfı">Ağır Vasıta</option>
                                    <option value="Traktör">Traktör (F)</option>
                                </select>
                                <input placeholder="KONUŞTUĞU DİLLER" className="bg-slate-950 p-4 rounded-2xl border border-slate-800" onChange={e => setYeniPersonel({...yeniPersonel, diller: e.target.value})} />
                                <textarea placeholder="PERSONEL HAKKINDA EK NOTLAR..." className="bg-slate-950 p-4 rounded-2xl border border-slate-800 h-24" onChange={e => setYeniPersonel({...yeniPersonel, aciklama: e.target.value})} />
                            </div>
                        </div>
                        <button onClick={personelEkle} className="w-full bg-blue-600 p-5 rounded-2xl font-black uppercase italic mt-8 shadow-xl hover:bg-blue-500 transition-all">Personeli Sisteme Kaydet</button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default StaffManager;